<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="audio_name"
        class="form-control-label">Name</label>
        <input
          required
          id="audio_name"
          v-model="item.name"
          :class="['form-control', !isValid('name') ? 'is-invalid' : 'is-valid']"
          type="text"
          maxlength="70"
          placeholder="">
          <small id="inputHelp" class="form-text text-muted">Maximum number of characters is 70</small>
      <div
        v-if="!isValid('name')"
        class="invalid-feedback">{{ violations.name }}</div>
    </div>
    <div class="form-group">
      <label
        for="audio_created"
        class="form-control-label">Created</label>
        <!-- <input
          id="audio_created"
          v-model="item.created"
          :class="['form-control', !isValid('created') ? 'is-invalid' : 'is-valid']"
          type="dateTime"
          placeholder=""> -->
          <date-picker value-type="YYYY-MM-DD" required="true" id="audio_created" class="w-100" :placeholder="createdDate" :default-value="item.created" v-model="item.created" type="date"></date-picker>          
      <div
        v-if="!isValid('created')"
        class="invalid-feedback">{{ violations.created }}</div>
    </div>
    <div class="form-group">
      <label
        for="audio_sourceUrl"
        class="form-control-label">Source Url</label>
        <input
          required
          id="audio_sourceUrl"
          v-model="item.sourceUrl"
          :class="['form-control', !isValid('sourceUrl') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('sourceUrl')"
        class="invalid-feedback">{{ violations.sourceUrl }}</div>
    </div>
    <!-- <div class="form-group">
      <label
        for="audio_speaker"
        class="form-control-label">Speaker</label>
        <input
          id="audio_speaker"
          v-model="item.speaker"
          :class="['form-control', !isValid('speaker') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('speaker')"
        class="invalid-feedback">{{ violations.speaker }}</div>
    </div> -->
    <div class="form-group">
      <label
        for="audio_speaker"
        class="form-control-label">Speaker</label>        
        <select        
          v-model="item.speaker"
          id="audio_speaker"
          class="form-control"
        >
          <option v-for="selectItem in speakerSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"                  
                  :selected="isSelected('speaker', selectItem['@id'])">
          {{ selectItem['name'] }}</option>
        </select>
      <div
        v-if="!isValid('speaker')"
        class="invalid-feedback">{{ violations.speaker }}</div>
    </div>
    <!-- <div class="form-group">
      <label
        for="audio_testimonials"
        class="form-control-label">testimonials</label>
        <select
          v-model="item.testimonials"
          id="audio_testimonials"
          multiple
          class="form-control"
        >
          <option v-for="selectItem in testimonialsSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"
                  :selected="isSelected('testimonials', selectItem['@id'])">{{ selectItem.name }}
          </option>
        </select>
      <div
        v-if="!isValid('testimonials')"
        class="invalid-feedback">{{ violations.testimonials }}</div>
    </div> -->

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>
  import ImageUploader from '../image-uploader/ImageUploader';
  import apiUrl from '../../store/modules/links/links';
  import { find, get, isUndefined } from 'lodash';
  import { mapFields } from 'vuex-map-fields';
  import { mapActions } from 'vuex';
  import moment from 'moment';

  export default {
  data() {
      return {
        createdDate: '',
        itemImage: '',
        time1: null,
      }
    },
  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },

    values: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => {},
    },

    initialValues: {
      type: Object,
      default: () => {},
    }
  },

  created() {
    this.imageGetSelectItems();     
    if (this.item.created != null) {      
      this.createdDate = moment(this.item.created).format("Y-MM-DD");  
    } else {      
      // this.item.created = moment().format("Y-MM-DD");
      // this.createdDate = moment().format("Y-MM-DD");
    } 
    
    if (this.item.image != null) {
      this.itemImage = this.item.image;  
    } else {
      this.itemImage = ''      
    }   

    if (this.item.speaker != null) {
      this.item.speaker = this.item.speaker['@id'];
    } 
  },

  mounted() {
    // this.testimonialsGetSelectItems();
    // this.speakersGetSelectItems();
    this.speakersGetAllSelectedItems();
    // this.getCurrentImagePath();
  },
  components: {
		'image-uploader': ImageUploader,		
	},
  computed: {
    // ...mapFields('testimonials/list', {
    //   'testimonialsSelectItems': 'selectItems',
    // }),
     ...mapFields('speaker/list', {
      'speakerSelectItems': 'selectItems',
    }),
    ...mapFields('mediaobject/list', {
      'imageSelectItems': 'selectItems',
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
      speakersGetSelectItems: 'speaker/list/getSelectItems',
      speakersGetAllSelectedItems: 'speaker/list/getAllSelectedItems',
      imageGetSelectItems: 'mediaobject/list/getSelectItems',
        // testimonialsGetSelectItems: 'testimonials/list/getSelectItems',
    }),

    isSelected(collection, id) {      
      return find(this.item[collection], ['@id', id]) !== undefined;
    },

    isValid(key) {
      return isUndefined(get(this.violations, key));
    },
    // This last two functions are for comunicating with image uploader
    imageUrlChanged(e) {
      console.log(e);      
      this.itemImage = apiUrl.API_HOST + e.contentUrl;      
      this.item.image = e['@id'];      
    },
    getCurrentImagePath() {      
      this.imageSelectItems.forEach(imageObject => {       
        if (imageObject['@id'] == this.itemImage) {
          this.itemImage = apiUrl.API_HOST + imageObject['contentUrl'];          
        }        
      });
    }
  },
};
</script>
<style lang="scss">
  .mx-input {
    border: 1px solid #28a745;
    color: #495057;
    &:hover {
      border-color: #28a745;      
    }
    &:focus {
      border-color: #28a745;
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
    }
  }
  .mx-icon-calendar {
    color: #28a745;
  }
</style>



// WEBPACK FOOTER //
// src/components/audio/Form.vue